import { buildPropsHelper } from './helpers/props';

export default {
  Hoverable: {
    ...buildPropsHelper(),

    mounted() {
      this.addHoverClassesCallback = this.addHoverClasses.bind(this);
      this.removeHoverClassesCallback = this.removeHoverClasses.bind(this);

      this.initialize();
    },

    updated() {
      if (this.propsChanged()) {
        this.removeEventListeners();
        this.initialize();
      }
    },

    getProps() {
      return {
        hoverableClasses: this.el.dataset.hoverableClasses,
        hoverableFor: this.el.dataset.hoverableFor,
      };
    },

    initialize() {
      this.setProps();

      this.targetElements = Array.from(this.el.getElementsByClassName(this.hoverableFor));

      this.addEventListeners();
    },

    destroyed() {
      this.removeEventListeners();
    },

    addHoverClasses(e) {
      if (e.target.closest('[phx-hook="Hoverable"]') != this.el) return;

      for (let targetElement of this.targetElements) {
        targetElement.classList.add(this.hoverableClasses);
      }
    },

    removeHoverClasses(e) {
      if (e.target.closest('[phx-hook="Hoverable"]') != this.el) return;

      for (let targetElement of this.targetElements) {
        targetElement.classList.remove(this.hoverableClasses);
      }
    },

    addEventListeners() {
      this.el.addEventListener('mouseover', this.addHoverClassesCallback);
      this.el.addEventListener('mouseout', this.removeHoverClassesCallback);
    },

    removeEventListeners() {
      this.el.removeEventListener('mouseover', this.addHoverClassesCallback);
      this.el.removeEventListener('mouseout', this.removeHoverClassesCallback);
    },
  },
};
